import Mutations from '../../odata/mutations';

export default { ...new Mutations('customerLocationTime'), ...new Mutations('customerLocationTimes') };
